export default __webpack_public_path__ + "static/BlueCrab-9c15dc4e6af8440e40934a4e1cec35a3.png";